import { useState, useEffect } from "react"
import { Outlet } from "react-router-dom"
import SideBar from "./global/SideBar"

const Layout = () => {

    const [user, setUser] = useState('')

    useEffect(() => {
        setUser(localStorage.getItem('user_id')&&atob(localStorage.getItem('user_id')) || '');
    }, [])

    return (
        <>
            <main className="App">
                <div className="main-panel">
                    {user ? <SideBar /> : null}
                    <div id="pageWrapper" className={user ? "wrapper" : null}>
                        {/* {user ? <TopHeader /> : null} */}
                        <div className={user ? "content" : null}>
                            <Outlet />
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}

export default Layout